import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').directive('emailValidator', emailValidator);

    /**
     * Validate email addresses
     * The validation has been taken from the JSF validator PhoneNumberValidator class
     *
     * @author flzemke.btc
     * @ngInject
     */
    function emailValidator(emailValidatorService) {
        return {
            restrict: 'A',
            require: 'ngModel',
            link: function (scope, element, attr, ctrl) {
                function emailValidator(ngModelValue) {
                    if (!ngModelValue) {
                        ctrl.$setValidity('emailValidator', true);
                        return ngModelValue;
                    }

                    //decide if one or multiple addresses have to be validated
                    var validatorFunc =
                        ngModelValue.indexOf(';') > -1
                            ? emailValidatorService.areValid
                            : emailValidatorService.isValid;

                    ctrl.$setValidity(
                        'emailValidator',
                        validatorFunc(ngModelValue)
                    );

                    return ngModelValue;
                }

                ctrl.$parsers.push(emailValidator);
            }
        };
    }
})();
